import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FiltersService} from '../../../../services/filters.service';
import {isNext} from '../../../../../core/utils/utils';

@Component({
  selector: 'app-mobile-filters-dialog',
  templateUrl: './mobile-filters-dialog.component.html',
  styleUrls: ['./mobile-filters-dialog.component.scss']
})
export class MobileFiltersDialogComponent implements OnInit {

  isNext = isNext();

  constructor(private dialogRef: MatDialogRef<MobileFiltersDialogComponent>,
              private filtersService: FiltersService,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  applyFilters() {
    this.filtersService.confirmMobileFilters();
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  clearFilters(): void {
    this.filtersService.resetFilters();
  }
}
